import { render, staticRenderFns } from "./AwardEnvirothon.vue?vue&type=template&id=071474ea&scoped=true&"
import script from "./AwardEnvirothon.vue?vue&type=script&lang=js&"
export * from "./AwardEnvirothon.vue?vue&type=script&lang=js&"
import style0 from "./AwardEnvirothon.vue?vue&type=style&index=0&id=071474ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071474ea",
  null
  
)

export default component.exports